module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGFJREFUeNrs2EENgDAMQNEFJUhAyiTgDCmThIRuHJBA0ob3k95f0svW1iR9V0TsmXHXmnvNkRX31jPjTjg4ODg4uHq4LI3HtlV62+VdMSQkJCQkpI97rdNHieOR9JemAAMAT9sZBTdfiuEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/back.png
// module id = BpN7
// module chunks = 1